module.exports = __webpack_public_path__ + "img/Team-ChristopherRussell.af54184a.png";